import {useSelector, useDispatch} from 'react-redux'
import {useState, useEffect} from 'react'
import {fetchUsers} from 'users/store/actions'
import {
  getCurrentUser,
  getAuthenticationState,
  getRegistrationState,
  getPasswordState,
  getUsers
} from 'users/store/selectors'

export const useCurrentUser = () => {
  const currentUser = useSelector(getCurrentUser)

  return currentUser
}

export const useAuthenticationState = () => {
  const state = useSelector(getAuthenticationState)

  const isAuthenticated = state.status === 'authenticated'

  return {
    isAuthenticated,
    ...state
  }
}

export const useRegistrationState = () => {
  const state = useSelector(getRegistrationState)

  return state
}

export const usePasswordState = () => {
  const state = useSelector(getPasswordState)

  return state
}

export const useUsers = () => {
  const state = useSelector(getUsers)
  const dispatchRedux = useDispatch()
  const [hasDispatched, setHasDispatched] = useState(false)

  useEffect(() => {
    // Only dispatch if we haven't already and there's no data
    if (!state.status && !hasDispatched) {
      dispatchRedux(fetchUsers({fetchAll: true}))
      setHasDispatched(true)
    }
  }, [state.status, hasDispatched, dispatchRedux])

  return state
}
